export const services = [
  {
    id: 'launch-accelerator',
    category: 'Career Launchpad',
    name: 'Launch Accelerator™',
    price: 149,
    applications: 5,
    description: 'Perfect for getting started with professional applications',
    features: [
      '5 applications completed',
      'Résumé alignment review (existing résumé required)',
      'One personalized cover letter template',
      'ATS-friendly formatting',
      'Application accuracy check',
      'Starter tracking sheet',
      'Professional communication guidance'
    ],
    bestFor: 'Quick start, career transitions',
    highlighted: false
  },
  {
    id: 'app-accelerator-5',
    category: 'Application Packs',
    name: 'Application Accelerator™ — 5 Applications',
    price: 199,
    applications: 5,
    description: 'Strategic application momentum for focused job seekers',
    features: [
      '5 applications completed',
      'Résumé alignment per role',
      'Custom cover letter per application',
      'ATS formatting + accuracy review',
      'Starter tracking sheet'
    ],
    bestFor: 'Targeted job search',
    highlighted: false
  },
  {
    id: 'app-accelerator-10',
    category: 'Application Packs',
    name: 'Application Accelerator™ — 10 Applications',
    price: 349,
    applications: 10,
    description: 'Build momentum with comprehensive application support',
    features: [
      '10 applications completed',
      'Tailored résumé + cover letter per role',
      'ATS-friendly formatting',
      'Job tracking chart'
    ],
    bestFor: 'Active job seekers',
    highlighted: false
  },
  {
    id: 'app-accelerator-15',
    category: 'Application Packs',
    name: 'Application Accelerator™ — 15 Applications',
    price: 499,
    applications: 15,
    description: 'Maximum momentum for serious job seekers',
    features: [
      '15 applications completed',
      'Role-specific résumé & cover letter for each',
      'ATS optimization & accuracy checks',
      'Job tracking chart'
    ],
    bestFor: 'Fast momentum, career pivots, overwhelmed job seekers',
    highlighted: true
  },
  {
    id: 'job-hunt-monthly',
    category: 'Monthly Services',
    name: 'Job Hunt Monthly Concierge™',
    price: 399,
    applications: 12,
    frequency: 'per month',
    commitmentPrice: 349,
    commitmentTerm: '3-month commitment',
    description: 'Your personal recruiter, every month',
    features: [
      '12 applications completed per month',
      'Tailored résumé & cover letter for each role',
      'Weekly curated job list (client-approved roles)',
      'Monthly LinkedIn profile refresh',
      'Ongoing strategy & messaging support',
      'Job tracking dashboard',
      'Biweekly progress updates'
    ],
    bestFor: 'Job seekers who want consistency without burnout',
    highlighted: true
  },
  {
    id: 'premium-takeover',
    category: 'Monthly Services',
    name: 'Premium Application Takeover™',
    price: 899,
    applications: 20,
    frequency: 'per month',
    packagePrice: 2400,
    packageTerm: '3-month engagement',
    description: 'White-glove job search management',
    features: [
      '20 applications completed monthly',
      'Full Executive Résumé Rewrite (included)',
      'Complete LinkedIn overhaul',
      'Tailored résumé + cover letter for every role',
      'Weekly coaching check-ins',
      'Priority 48-hour turnaround per application',
      'Dedicated recruiter strategy support'
    ],
    bestFor: 'Executives and serious career advancement',
    highlighted: false
  }
];

export const addOns = [
  {
    id: 'job-search-cycle',
    name: 'Job Search Add-On — Cycle',
    price: 99,
    description: '5–10 job leads curated to your experience',
    features: [
      'Curated roles aligned to your experience',
      'Qualification screening',
      'Priority application recommendations',
      'Roles added directly to tracking chart',
      'Optional same-day application fulfillment'
    ]
  },
  {
    id: 'job-search-extended',
    name: 'Job Search Support — 30 Days',
    price: 199,
    description: 'Extended role sourcing for 30 days',
    features: [
      'Continuous job sourcing for 30 days',
      'Curated roles aligned to your experience',
      'Qualification screening',
      'Priority application recommendations',
      'Direct integration with tracking chart'
    ]
  },
  {
    id: 'visibility-diy',
    name: 'Post-Apply Power Play™ — DIY Guide',
    price: 29,
    description: 'A structured follow-up system to keep your candidacy visible',
    features: [
      'Follow-up framework',
      'Professional messaging templates',
      'Timing guidance',
      'Self-directed implementation'
    ]
  },
  {
    id: 'visibility-toolkit',
    name: 'Post-Apply Power Play™ — Visibility Toolkit (Done-With-You)',
    price: 79,
    description: 'Templates, scripts, and walkthrough support',
    features: [
      'Professional templates and scripts',
      'Step-by-step walkthrough',
      'Personalization guidance',
      'Follow-up timing strategies'
    ]
  },
  {
    id: 'visibility-boost',
    name: 'Post-Apply Power Play™ - Visibility Boost (Done-For-You)',
    price: 99,
    bundlePrice: 299,
    bundleTerm: '5-role bundle',
    description: 'Complete follow-up service per role',
    features: [
      'Hiring manager identification',
      'Custom intro message written',
      'Follow-up email written & timed',
      'Guidance on who not to contact',
      'Application + outreach alignment check'
    ]
  },
  {
    id: 'linkedin-optimization',
    name: 'LinkedIn Optimization',
    price: 149,
    description: 'Complete LinkedIn profile refresh',
    features: [
      'Headline optimization',
      'About section rewrite',
      'Skills alignment',
      'Recruiter-ready layout'
    ]
  },
  {
    id: 'interview-coaching',
    name: '60-Min Interview Coaching',
    price: 99,
    description: 'One-on-one interview preparation',
    features: [
      '60-minute 1:1 session',
      'Interview prep strategies',
      'Recruiter feedback',
      'Practice and refinement'
    ]
  },
  {
    id: 'rush-upgrade',
    name: '48-Hour Rush Upgrade',
    price: 75,
    description: 'Fast-track your application pack with priority processing',
    features: [
      'Priority processing',
      '48-hour turnaround per application pack',
      'Urgent application support',
      '$75 per application pack'
    ]
  }
];

export const faqs = [
  {
    question: 'How does the service work?',
    answer: 'Choose a service package, complete our intake survey, and we\'ll start applying to jobs on your behalf. You provide the job links or let us source roles for you (with job search add-on). We handle everything from résumé customization to application submission, and provide tracking so you always know what\'s been submitted.'
  },
  {
    question: 'Do you guarantee interviews or job offers?',
    answer: 'No. We cannot guarantee outcomes because hiring decisions are made by employers. However, we can guarantee quality, strategy, and recruiter-level execution on every application. Our goal is to maximize your chances by submitting applications that stand out.'
  },
  {
    question: 'What\'s the difference between your service and AI job application tools?',
    answer: 'AI tools use mass submissions with generic, keyword-stuffed applications that employers can spot instantly. We provide human-led, strategic applications with real recruiter oversight. Every résumé and cover letter is customized for the specific role—no bots, no shortcuts, no spam.'
  },
  {
    question: 'Can I choose which jobs you apply to?',
    answer: 'Yes! You provide the job links or postings you want us to apply to. If you need help finding roles, our Job Search Add-On provides curated job leads based on your experience and goals.'
  },
  {
    question: 'How long does it take to complete applications?',
    answer: 'Standard turnaround is within 3-5 business days per application pack. Monthly services follow a steady pace throughout the month. Need it faster? Our 48-hour rush upgrade is available for $75 per application pack.'
  },
  {
    question: 'What if I don\'t have a current résumé?',
    answer: 'Most of our services work with your existing résumé and tailor it per role. If you need a complete résumé rewrite, our Premium Application Takeover™ includes a full executive résumé overhaul. Alternatively, we can provide guidance on creating a foundational résumé during intake.'
  },
  {
    question: 'Will employers know someone else submitted my application?',
    answer: 'No. We submit applications on your behalf using your information and credentials. Everything appears as if you submitted it yourself—professionally, accurately, and strategically.'
  },
  {
    question: 'What industries and experience levels do you support?',
    answer: 'We support job seekers across all industries and experience levels—from entry-level to C-suite executives. Our team has 20+ years of professional recruiting experience and adapts our strategy to your unique background and goals.'
  },
  {
    question: 'Can I cancel or pause my monthly service?',
    answer: 'Monthly services can be paused or canceled with 7 days\' notice before your next billing cycle. Three-month commitments require completion of the commitment period. Contact us to discuss your specific situation.'
  },
  {
    question: 'How do I get started?',
    answer: 'Select a service package and complete the purchase. You\'ll receive an email with next steps, including our intake survey to gather your job search details, résumé, and preferences. Once we have your information, we\'ll begin working on your applications immediately.'
  }
];